import {ROUTER_REDUX_ACTION_NAME} from '../../core/route/routeConstants';

/* Utils */
import {isCollectionPageRouting, matchUrlInRouteConfigs} from '../../core/route/routeUtils';
import {setWindowScrollTop} from '../../common/dom/domUtils';

function enterRoute(dispatch, actionName) {
  dispatch({
    type: actionName,
    payload: {},
    isEnterRouteAction: true,
  });
}

function leaveRoute(dispatch, actionName) {
  dispatch({
    type: actionName,
    payload: {},
    isLeaveRouteAction: true,
  });
}

let isInitialLocationChange = true;

function routeNavigationMiddleware({dispatch, getState}) {
  return function(next) {
    return function(action) {
      let nextResult;

      if (action.type === ROUTER_REDUX_ACTION_NAME) {
        const rewriteUrlFromState = getState()?.staticPageState?.rewriteUrl?.rewriteUrl

        const nextMatch = matchUrlInRouteConfigs(rewriteUrlFromState ? `/${rewriteUrlFromState}` : action.payload.location.pathname);
        const currentMatch = matchUrlInRouteConfigs(rewriteUrlFromState ? `/${rewriteUrlFromState}` : getState().router.location.pathname);
        const isCollectionPageRouteChange = isCollectionPageRouting({nextRoute: nextMatch, currentRoute: currentMatch})

        if (nextMatch?.path !== currentMatch?.path && !isCollectionPageRouteChange) {
          const {preventScrollToTop = false} = action?.payload?.location?.state || {};

          if (currentMatch?.onLeaveActionName) {
            leaveRoute(dispatch, currentMatch?.onLeaveActionName);
          }

          if (nextMatch?.onEnterActionName) {
            enterRoute(dispatch, nextMatch?.onEnterActionName);
          }

          if (action.payload.action !== 'POP' && !preventScrollToTop) {
            setWindowScrollTop(0);
          }
        }

        if (isInitialLocationChange) {
          action.isInitialLocationChange = true;

          isInitialLocationChange = false;
        }

        nextResult = next(action);
      } else {
        nextResult = next(action);
      }

      return nextResult;
    };
  };
}

export default routeNavigationMiddleware;
